import React from 'react';
import Helmet from 'react-helmet';
import { string } from 'prop-types';

const TitleComponent = ({ title }) => (
  <Helmet>
    <title>{title}</title>
  </Helmet>
);

TitleComponent.propTypes = {
  title: string,
};

TitleComponent.defaultProps = {
  title: '',
};

export default TitleComponent;



// WEBPACK FOOTER //
// ./src/components/title/index.js